<div>
    <h1>
        Software Development Lead
    </h1>
    <p>experiential media | digital marketing</p>
    <div class="list">
        <div class="sub-list">
            <span>FRONTEND</span>     
            <ul>
                <li>Typescript | Javascript | ECMAScript</li>
                <li>Angular | VueJS | Handlebars | Pug | EJS | Twig | Mustache | Meteor | KeystoneJS | Sculpin | Drupal</li>
                <li>SASS | LESS | Bootstrap | Foundation | Semantic UI | Ionic</li>
                <li>Mobile-first Responsive Development</li>
                <li>ElectronJS | Cordova</li>
                <li>D3</li>
            </ul>

        </div>
        <div class="sub-list">
            <span>BACKEND</span>     
            <ul>
                <li>AWS | Github Pages | Heroku | Digital Ocean
                </li>
                <li>Helm | Docker | Django | NodeJS</li>
                <li>Express | Nginx</li>
                <li>MongoDB | Directus | MySQL | PostgresQL</li>
            </ul>

        </div>
        <div class="sub-list">
            <span>Additional Skills</span>
            <ul>
                <li>CLI: Bash | DOS | iTerm | GitBash 
                </li>
                <li>OS: Windows | Mac | Linux | Ubuntu</li>
                <li>Version Control: GIT | Perforce | Bitbucket | Github</li>
                <li>PHP | Python | Java | C# | C++ | Ruby on Rails</li>
                <li>Laravel | NPM | Symphony | Homebrew | Bower</li>
                <li>IBM Watson</li>
                <li>Unity</li>
            </ul>
        </div>
    </div>
</div>